module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    attrs: {
      "modifier": "secondary"
    }
  }, [_c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('map-component')], 1), _vm._v(" "), _c('automatic-area-updater')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f28575","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/index.vue
// module id = 777
// module chunks = 0